import { modifier } from 'ember-modifier'

interface ApplyValueSignature {
  Element: HTMLElement
  Args: {
    Named: Record<string, boolean | string | null | undefined>
  }
}

/**
 * Some bindings only apply in javascript (eg <select value={{eq opt.id selected.id}} />) - that is fine functionally,
 * but we also need the DOM to reflect that for diff snapshots, as only the DOM snapshot is sent.
 */
export const applyAttr = modifier<ApplyValueSignature>(function (element, _pos, named) {
  Object.entries(named).forEach(([attr, value]) => {
    if (value) {
      element.setAttribute(attr, value.toString())
    } else {
      element.removeAttribute(attr)
    }
  })
})

export default applyAttr
